import { configureStore } from '@reduxjs/toolkit';
import botReducer from './botSlice';
import contactReducer from './contactSlice';
import partnershipReducer from './partnershipSlice'
import postsReducer from './postsSlice'

export const store = configureStore({
    reducer: {
        bot: botReducer,
        contact: contactReducer,
        partnership: partnershipReducer,
        posts: postsReducer
    },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;